<template>
  <div class="subfinance-page common-bg">
    <div class="filter-bar">
      <div class="filter-item" @click="showDate = !showDate">
        <span>{{ dateOptions[dateIndex].text }}</span>
        <van-icon name="arrow-down" size="10" />
      </div>
      <div class="filter-item" @click="showSort = !showSort">
        <span>{{ sortOptions[sortIndex].text }}</span>
        <van-icon name="arrow-down" size="10" />
      </div>
      <div class="search-box">
        <input v-model="searchKeyword" type="text" placeholder="会员ID" class="search-input" />
        <van-icon name="search" size="16" color="#888" class="search-icon" @click="handleSearch" />
      </div>

      <!-- 日期筛选弹窗 -->
      <div class="filter-overlay" v-if="showDate" @click="showDate = false"></div>
      <div class="filter-dropdown" v-if="showDate">
        <div class="filter-content">
          <div class="filter-tabs">
            <div class="filter-tab" v-for="(item, index) in dateOptions" :key="index" :class="{ active: dateIndex === index }" @click="dateIndex = index">
              {{ item.text }}
            </div>
          </div>
          <div class="custom-date">
            <div class="custom-title">自定义</div>
            <div class="date-inputs">
              <div class="date-input-box">
                <div class="date-label">开始日期</div>
                <div class="date-picker">
                  <span class="date-num">{{ startDate.month }}</span>
                  <span class="date-num">{{ startDate.day }}</span>
                  <span class="date-year">{{ startDate.year }}</span>
                </div>
              </div>
              <div class="date-input-box">
                <div class="date-label">结束日期</div>
                <div class="date-picker">
                  <span class="date-num">{{ endDate.month }}</span>
                  <span class="date-num">{{ endDate.day }}</span>
                  <span class="date-year">{{ endDate.year }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-btns">
            <div class="filter-btn cancel" @click="showDate = false">取消</div>
            <div class="filter-btn confirm" @click="showDate = false; loadData()">确认</div>
          </div>
        </div>
      </div>

      <!-- 排序筛选弹窗 -->
      <div class="filter-overlay" v-if="showSort" @click="showSort = false"></div>
      <div class="filter-dropdown" v-if="showSort">
        <div class="filter-content">
          <div class="filter-tabs">
            <div class="filter-tab" v-for="(item, index) in sortOptions" :key="index" :class="{ active: sortIndex === index }" @click="sortIndex = index">
              {{ item.text }}
            </div>
          </div>
          <div class="filter-btns">
            <div class="filter-btn cancel" @click="showSort = false">取消</div>
            <div class="filter-btn confirm" @click="showSort = false; loadData()">确认</div>
          </div>
        </div>
      </div>
    </div>

    <div class="finance-list" v-if="financeList.length > 0">
      <div class="finance-item" v-for="(item, index) in financeList" :key="index">
        <div class="finance-left">
          <div class="finance-type">{{ item.type }}</div>
          <div class="finance-time">{{ item.time }}</div>
        </div>
        <div class="finance-right">
          <div class="finance-amount" :class="{ plus: item.amount > 0, minus: item.amount < 0 }">
            {{ item.amount > 0 ? '+' : '' }}{{ item.amount }}
          </div>
          <div class="finance-status" :class="item.statusClass">{{ item.status }}</div>
        </div>
      </div>
    </div>

    <div class="empty-state" v-else>
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoteSubFinance',
  data() {
    return {
      dateIndex: 0,
      sortIndex: 0,
      searchKeyword: '',
      showDate: false,
      showSort: false,
      startDate: { year: '2026', month: '07', day: '07' },
      endDate: { year: '2026', month: '07', day: '07' },
      dateOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '上周', value: 3 },
        { text: '本月', value: 4 },
        { text: '上月', value: 5 },
        { text: '全部', value: 6 },
      ],
      sortOptions: [
        { text: '充值金额排序', value: 0 },
        { text: '提现金额排序', value: 1 },
      ],
      financeList: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let that = this;
    },
    handleSearch() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.subfinance-page {
  min-height: 100vh;
  background: #1E1F24;
  padding-bottom: 1rem;

  .filter-bar {
    background: #1E1F24;
    padding: 0.2rem 0.15rem;
    display: flex;
    align-items: center;
    gap: 0.12rem;
    position: relative;
    z-index: 1;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 0.06rem;
      padding: 0.1rem 0.18rem;
      background: #292A2C;
      border: 1px solid #3B3C3D;
      border-radius: 0.3rem;
      font-size: 0.24rem;
      color: #fff;
      position: relative;
      white-space: nowrap;
    }

    .search-box {
      flex: 1;
      display: flex;
      align-items: center;
      background: #292A2C;
      border: 1px solid #3B3C3D;
      border-radius: 0.3rem;
      padding: 0 0.15rem;
      height: 0.52rem;

      .search-input {
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        color: #fff;
        font-size: 0.24rem;

        &::placeholder {
          color: #888;
        }
      }

      .search-icon {
        flex-shrink: 0;
      }
    }

    .filter-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 199;
    }

    .filter-dropdown {
      position: fixed;
      top: 3rem;
      left: 0;
      right: 0;
      background: #1E1F24;
      z-index: 200;
      padding: 0.25rem;
      border-bottom-left-radius: 0.2rem;
      border-bottom-right-radius: 0.2rem;

      .filter-tabs {
        display: flex;
        flex-wrap: wrap;
        gap: 0.12rem;
        margin-bottom: 0.25rem;

        .filter-tab {
          width: calc(33.333% - 0.08rem);
          text-align: center;
          padding: 0.18rem 0;
          background: #292A2C;
          border: 1px solid #3B3C3D;
          border-radius: 0.12rem;
          color: #fff;
          font-size: 0.28rem;

          &.active {
            color: #DFB372;
            border-color: #DFB372;
          }
        }
      }

      .custom-date {
        margin-bottom: 0.25rem;

        .custom-title {
          font-size: 0.26rem;
          color: #fff;
          margin-bottom: 0.15rem;
        }

        .date-inputs {
          display: flex;
          gap: 0.2rem;

          .date-input-box {
            flex: 1;
            background: #292A2C;
            border: 1px solid #3B3C3D;
            border-radius: 0.12rem;
            padding: 0.2rem;

            .date-label {
              font-size: 0.24rem;
              color: #888;
              text-align: center;
              margin-bottom: 0.15rem;
            }

            .date-picker {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 0.15rem;

              .date-num {
                font-size: 0.32rem;
                color: #fff;
                font-weight: bold;
              }

              .date-year {
                font-size: 0.24rem;
                color: #888;
              }
            }
          }
        }
      }

      .filter-btns {
        display: flex;
        gap: 0.2rem;

        .filter-btn {
          flex: 1;
          text-align: center;
          padding: 0.2rem 0;
          border-radius: 0.3rem;
          font-size: 0.3rem;

          &.cancel {
            color: #DFB372;
            border: 1px solid #DFB372;
            background: transparent;
          }

          &.confirm {
            color: #333;
            background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
          }
        }
      }
    }
  }

  .finance-list {
    padding: 0.2rem;

    .finance-item {
      background: #292A2C;
      border-radius: 0.12rem;
      padding: 0.2rem;
      margin-bottom: 0.15rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .finance-left {
        .finance-type {
          font-size: 0.26rem;
          color: #fff;
          margin-bottom: 0.08rem;
        }

        .finance-time {
          font-size: 0.22rem;
          color: #888;
        }
      }

      .finance-right {
        text-align: right;

        .finance-amount {
          font-size: 0.3rem;
          font-weight: bold;
          margin-bottom: 0.08rem;

          &.plus {
            color: #3CC82F;
          }

          &.minus {
            color: #ff4d4f;
          }
        }

        .finance-status {
          font-size: 0.22rem;

          &.success {
            color: #3CC82F;
          }

          &.pending {
            color: #DFB372;
          }

          &.fail {
            color: #ff4d4f;
          }
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;

    .empty-icon-wrap {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.4rem;

      .empty-icon {
        width: 2.5rem;
        height: 2.5rem;
        opacity: 0.5;
      }
    }

    .empty-text {
      font-size: 0.28rem;
      color: #666;

      .empty-link {
        color: #DFB372;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/SubFinance.vue